import React from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { MoodDetailsData } from './ContainMoodDetails';
import { PresentMoodDetails } from './PresentMoodDetails';

const chip = (key: string, label: string, selected = false) => ({ key, label, selected });

const DATA: MoodDetailsData = {
  feelingsTitle: 'How did you feel today?',
  keywordsTitle: 'Your day in a few keywords',
  feelingOptions: [
    chip('FEELING_JOYFUL', 'Joyful', true),
    chip('FEELING_CALM', 'Calm'),
    chip('FEELING_TIRED', 'Tired'),
    chip('FEELING_STRESSED', 'Stressed'),
    chip('FEELING_GRATEFUL', 'Grateful', true),
  ],
  onToggleFeeling: () => undefined,
  keywordOptions: [
    chip('KEYWORD_WORK', 'Work'),
    chip('KEYWORD_FAMILY', 'Family', true),
    chip('KEYWORD_SPORT', 'Sport'),
    chip('KEYWORD_FRIENDS', 'Friends'),
  ],
  onToggleKeyword: () => undefined,
};

const meta = {
  title: 'Diary/Frames/MoodDetails',
  component: PresentMoodDetails,
  args: {
    questionId: 'story-mood',
    questionText: 'Tell us about your day',
    margin: 16,
    data: DATA,
  },
  decorators: [
    Story => (
      <View style={{ width: 375, height: 640 }}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof PresentMoodDetails>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
